import { TranslateSet } from './translate.model';

var languageValuesEN: TranslateSet = {
    languange: 'en-GB',
    values: {
        language: 'Language',
        expressionCalculator: 'Expression calculator',
        expressionName: 'Expression name',
        returnType: 'Return type',
        number: 'Number',
        string: 'String',
        expression: 'Expression',
        customFunctions: 'Custom functions',
        fixedFunctions: 'Fixed functions',
        variables: 'Variables',
        cancel: 'Cancel',
        submit: 'Submit'
    },
};

export default languageValuesEN;